import { render, staticRenderFns } from "./ParkingConfigurationForm.vue?vue&type=template&id=6ad62a2a&scoped=true"
import script from "./ParkingConfigurationForm.vue?vue&type=script&lang=js"
export * from "./ParkingConfigurationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad62a2a",
  null
  
)

export default component.exports